export default [
  {
    path: '/ErpIntegrationLog',
    name: 'erp-integration-log',
    meta: {
      permission: 'provider.ErpIntegrationLog.view',
    },
    component: () => import('@/views/erpIntegrationLog/Main.vue'),
  },
];
